<script>
import options from './DropdownWithTags.options'
export default options
</script>

<template>
  <article class="kb-dropdown-with-tags">
      <div class="kb-stafet-step__input-wrapper kb-js--dropdown-with-tags-wrapper" >

        <FormInputDropdown 
          v-model="tagsDropdown" 
          fieldName="subjectTags" 
          :isRequired="isRequired"
          :modelValue="tagsDropdown"
          :label="label" 
          :isValidationError="isValidationError" 
          :placeholder="placeholder" 
          :errorMessageLabel="errorMessageLabel"
          :selectOptions="subjectOptions" 
          :onChangeCallback="(e) => (handleSubjectsOptions(e))
          " />

      </div>

    <div v-if="tags.length > 0" class="kb-dropdown-with-tags__tags-wrapper">
     
      <p class="kb-dropdown-with-tags__tags-title" id="tags-title">
        {{ tagsTitle }}
      </p>
      <ul class="kb-dropdown-with-tags__tags-list">
        <template v-for="(tag, index) in tags" :key="index">
          <li  class="kb-dropdown-with-tags__tags-tag-wrapper" >
            <button 
            @click="handleDeleteTag(tag)" 
            aria-labelledby="tags-title"
            class="kb-dropdown-with-tags__tags-tag" 
            :index="index">
              {{tag}}
              <span class="kb-visually-hidden">- klik for at slette</span>
              <svg role="presentation" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.293 3.897.146 7.043l.708.707L4 4.604 7.146 7.75l.708-.707-3.147-3.146L7.854.75 7.146.043 4 3.189.854.043.146.75l3.147 3.147Z" fill="#3C3C3C"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h8v8H0z"/></clipPath></defs></svg>
            </button>
          </li>
        </template>
      </ul>

    </div>

  </article>
</template>
